import { render } from "./displaymodulebp.vue?vue&type=template&id=ec836bac"
import script from "./displaymodulebp.vue?vue&type=script&lang=js"
export * from "./displaymodulebp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__